import React from 'react';
import './AboutSection.css';
import ContactUs from '../../../pages/ContactUs/ContactUs';

function AboutSection() {
  return (
    <div className='about-container'>
      <div className='about-content'>
        <div className='about-text-wrapper'>
          <div className='about-header'>
            <div>
              <h2 className='about-heading'>About FOMEJE</h2>
              <p className='about-subtitle'>The Mediterranean Forum For Youth</p>
            </div>
          </div>
          <div className='about-description'>
            <p>
              Established on September 2, 2005, in Assilah, Morocco, FOMEJE is a dynamic youth organization created to address the ambitions of young individuals from Morocco with African roots, Mediterranean civilization, and universal cultural values. It aims to provide a constructive space within the evolving "society of information," reshaping social, moral, cultural concepts, and international relations. The Forum is open to all local, national and international initiatives for which they exchange their experiences and expertise with openness and acceptance of all differences, respecting diversity and living in harmony with the cultural and civilizational contrast with tolerance confirming the essence of the universal slogan <span className="highlighted-slogan">"We are different ... We are equal"</span>.
            </p>
            <p>
              <strong>Vision:</strong>
            </p>
            <p>
              Our vision is of a world where young people are responsible, engaged, creative, and initiators of positive change.
            </p>
            <p>
              <strong>Mission:</strong>
            </p>
            <p>
              Our mission is to equip young Moroccans with the skills and opportunities needed to effectively represent themselves in local, regional, national, and international bodies, ensuring better governance and societal development.
            </p>
            <p>
              <strong>Address:</strong> The Education and Training Center, P.O. Box 246, Assilah 90050, Morocco
            </p>
            <div className="about-social">
              <ContactUs />
            </div>
          </div>
        </div>
        <div className='about-img-wrapper'>
          <img src={"../images/fomeje-logo-2025.png"} alt="FOMEJE Logo" className='about-logo' />
          <div className='stats-container'>
            <div className='stat-item'>
              <span className='stat-number'>1000+</span>
              <span className='stat-label'>Youth Impacted</span>
            </div>
            <div className='stat-item'>
              <span className='stat-number'>50+</span>
              <span className='stat-label'>Projects</span>
            </div>
            <div className='stat-item'>
              <span className='stat-number'>20+</span>
              <span className='stat-label'>Partners</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutSection; 